import { Document as ReactPDFDocument } from '@react-pdf/renderer';

export const Document = ReactPDFDocument;
